import { Component, inject } from '@angular/core';
import { FormWrapperComponent } from '../../../ui/form-wrapper/form-wrapper.component';
import { RecipientsService } from '../../../../services/campaign/recipients.service';
import { WizardAudienceService } from '../../../../pages/organization/campaigns/create-campaign/wizard-audience.service';
import { formatCount } from '../../../../../utils/sms';

/** Step 2 summary: the unique audience, live, and the groups behind it. */
@Component({
  selector: 'app-recipients-preview',
  standalone: true,
  imports: [FormWrapperComponent],
  templateUrl: './recipients-preview.component.html',
  styleUrl: '../campaign-preview.css',
})
export class RecipientsPreviewComponent {
  recipients = inject(RecipientsService);
  audience = inject(WizardAudienceService);

  readonly formatCount = formatCount;
}
